import * as Yup from "yup";

export const CreateUserFormSchema = Yup.object().shape({
  fullName: Yup.string()
    .required("This field is required")
    .matches(/^[\w\-\s]+$/, "Invalid input"),
  email: Yup.string()
    .email("Must be a valid email")
    .required("This field is required"),
  accessType: Yup.string().required("This field is required"),
  password: Yup.string()
    .required("This field is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d]|.*[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?])[A-Za-z\d!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]{8,}$/,
      "Password combination must be At least 8 characters, At least 1 lowercase character, At least 1 uppercase character, At least 1 number or special character"
    ),
});
